import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "highlight" })
export class HighlightSearch implements PipeTransform {

    transform(value: any, searchTerms: string): any {
        if (!searchTerms) {return value;}

        var trimmedTerm = searchTerms.toString().trim();
        if(trimmedTerm != "") {
            var re = new RegExp(trimmedTerm, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
            value = value.toString().replace(re, "<mark>$&</mark>");
        }
        return value;
    }
}